<template>
  <div class="logs">
    <v-data-table
      :headers="infor_header"
      :items="control"
      hide-actions
      disable-initial-sort
      class="elevation-0 datatable"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.date }}</td>
        <td>{{ props.item.ip }}</td>
        <td>{{ props.item.api }}</td>
        <td>{{ props.item.client }}</td>
        <td>{{ props.item.results | formatnumber }}</td>
        <td>{{ props.item.query }}</td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: ["user"],
  computed: {
    ...mapGetters(["getTokenHeader", "getServer", "getUserId"])
  },
  created() {
    const userid = this.user ? parseInt(this.user, 0) : this.getUserId;
    this.$http
      .get(`${this.getServer}/users/${userid}/control`, this.getTokenHeader)
      .then(data => {
        if (data.data && Array.isArray(data.data)) this.control = data.data;
      });
  },
  data() {
    return {
      infor_header: [
        { text: "Date", sortable: false, value: "date" },
        { text: "ip", sortable: false, value: "ip" },
        { text: "API", sortable: false, value: "api" },
        { text: "Client", sortable: false, value: "client" },
        { text: "Results", sortable: false, value: "results" },
        { text: "Query", sortable: false, value: "query" }
      ],
      control: []
    };
  }
};
</script>
<style scoped>
  .logs{
  padding: 25px !important;
}
</style>